export default {
    MEDICAMENTO: 1,
    EXAME: 2,
    MATERIAL: 3,
    CIRURGIA: 4,
    MANUTENCAO: 5,
}